import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f6cee616"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "close-container" }
const _hoisted_2 = { class: "form-group-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Impresora", -1))
const _hoisted_4 = ["value"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Dades del client (només si es vol factura)", -1))
const _hoisted_6 = { class: "form-group-container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Nom", -1))
const _hoisted_8 = { class: "form-group-container" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "NIF", -1))
const _hoisted_10 = { class: "form-group-container" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Adreça", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_simple_typeahead = _resolveComponent("simple-typeahead")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, [
              _createVNode(_component_ion_icon, { icon: _ctx.closeOutline }, null, 8, ["icon"])
            ])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.printer_id) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.printers, (printer) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: printer.id,
                  key: printer.id
                }, _toDisplayString(printer.name), 9, _hoisted_4))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.form.printer_id]
            ])
          ]),
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_simple_typeahead, {
              items: _ctx.clients,
              minInputLength: 3,
              onOnInput: _ctx.lookupClients,
              onSelectItem: _ctx.handleSelectClient,
              itemProjection: (item) => { return item.name; }
            }, null, 8, ["items", "onOnInput", "onSelectItem", "itemProjection"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              name: "id_doc",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.id_doc) = $event))
            }, null, 512), [
              [_vModelText, _ctx.form.id_doc]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _withDirectives(_createElementVNode("input", {
              name: "address",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.address) = $event))
            }, null, 512), [
              [_vModelText, _ctx.form.address]
            ])
          ]),
          _createElementVNode("button", {
            class: "add-btn",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.print && _ctx.print(...args)))
          }, " Imprimir ")
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}